import { toast } from "./components/ui/use-toast"
import { Result } from "./utils"

export function toastResult<T, E extends Error>(
  res: Result<T, E>,
  success: string,
  error?: string
) {
  if (res.ok) {
    toast({
      title: "Success",
      description: success,
    })
  } else {
    toast({
      title: "Error",
      description: error ? error + ": " + res.error.message : res.error.message,
    })
    console.error(`Failed to assign tasks: ${res.error.message}`)
  }
}
